import {
  Box,
  Button,
  Card,
  CloseButton,
  Container,
  Flex,
  Select,
  SimpleGrid,
  Text,
  TextInput,
  createStyles,
  rem,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useSelector } from "react-redux";
import { updateBusinessProfile } from "../../../../services/profile";
import { PhoneInput } from "react-international-phone";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { useEffect, useState } from "react";
import { GoChevronDown } from "react-icons/go";

const useStyles = createStyles((theme) => ({
  wrapper: {
    marginTop: 40,
    marginBottom: 40,
    borderWidth: 1,
    borderRadius: 15,
    borderStyle: "solid",
    borderColor: "#FFDEABEE",
    display: "flex",
    flexDirection: "row",
    overflow: "visible",
  },
  camera: {
    position: "absolute",
    marginTop: 75,
    marginLeft: 75,
    background: "#FFBA45",
    borderRadius: "50%",
    padding: 5,
    [`&:hover`]: {
      cursor: "pointer",
    },
  },
  box: {
    width: 280,
    paddingTop: 47,
    borderRightWidth: 1,
    borderRightStyle: "solid",
    borderRightColor: "#F2F2F2",
    textAlign: "center",
  },
  inputIcon: {
    borderRightWidth: 1,
    borderRigthColor: "#CBCBCB",
    borderRightStyle: "solid",
    paddingRight: 5,
  },
  changepwd: {
    position: "absolute",
    color: "#FFBA45",
    fontFamily: "Inter",
    fontSize: rem(14),
    marginLeft: "auto",
    textDecoration: "underline",
    paddingBottom: 10,
    marginTop: 9,
  },
  btn: {
    width: 122,
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 500,
  },
  inputContainer: {
    "@media (max-width :40em)": {
      display: "flex",
      flexDirection: "column",
      paddingBottom: "4rem",
    },
  },
  label: {
    margin: "4px",
    width: "100%",
  },
  phoneInput: {
    "& button": {
      height: "2.625rem",
      borderColor: "f1f3f5 !important",
    },
    "& .react-international-phone-input": {
      height: "2.625rem !important",
      borderColor: "f1f3f5 !important",
      width: "100%",
    },
  },
  selectedTypesWrapper: {
    borderRadius: 4,
    border: "1px solid #D0D5DD",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    padding: "5px",
    minHeight: 44,
  },
  selectedTypeTag: {
    borderRadius: 16,
    padding: "4px 12px",
    backgroundColor: "#F2F4F7",
  },
}));
const mockBusinessTypes = [
  "QDDP",
  "Billing Agency",
  "Accounting",
  "Documentation Specialist",
  "Home Health Agency",
  "Staffing Agency",
  "Consulting Firm",
  "Therapy Provider",
  "Others",
];

const BusinessProfile = () => {
  const { profile, saveProfileLoading } = useSelector(
    (state) => state?.profile
  );
  const { classes } = useStyles();
  const navigate = useNavigate();

  const form = useForm({
    initialValues: {
      businessEmail: profile?.business?.businessEmail,
      companyName: profile?.business?.companyName,
      contactPhone: profile?.business?.contactPhone,
      industry: profile?.business?.industry,
    },
    validate: (values) => {
      const errors = {};
      const isSkyPoint = profile?.business?.type === "skypoint";

      if (isSkyPoint) {
        if (!values.companyName) errors.companyName = "Required";
        return errors;
      }

      if (!values.companyName) errors.companyName = "Required";
      if (!/^\S+@\S+$/.test(values.businessEmail))
        errors.businessEmail = "Invalid email";
      if (!values.contactPhone) errors.contactPhone = "Required";
      if (!values.industry) errors.industry = "Required";
      if (!values.companyName) errors.companyName = "Required";

      return errors;
    },
  });

  const [selectedTypes, setSelectedTypes] = useState([]);
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [otherValue, setOtherValue] = useState("");
  const [customFormErrors, setCustomFormErrors] = useState({
    selectedTypes: null,
    otherValue: null,
  });

  const handleSelectChange = (value) => {
    if (!value) return;

    if (value === "Others") {
      setShowOtherInput(true);
    } else if (!selectedTypes.includes(value)) {
      setSelectedTypes([...selectedTypes, value]);
      setShowOtherInput(false);
    }
  };

  const handleOtherInputKeyDown = (event) => {
    if (event.key === "Enter" && otherValue.trim() !== "") {
      event.preventDefault();

      const newValue = otherValue.trim();

      if (!selectedTypes.includes(newValue)) {
        setSelectedTypes([
          ...selectedTypes.filter((v) => v !== "Other"),
          newValue,
        ]);
      }

      setOtherValue("");
      setCustomFormErrors((prev) => ({ ...prev, otherValue: null }));
    }
  };

  useEffect(() => {
    setSelectedTypes(profile?.business?.businessTypes || []);
  }, [profile?.business]);

  const onFinish = async (values) => {
    try {
      let errors = {};

      if (selectedTypes.length === 0) {
        errors.selectedTypes = "Please select at least one business type";
      }

      if (showOtherInput && !otherValue.trim() && selectedTypes.length === 0) {
        errors.otherValue = "Please enter a business type or press Enter";
      }

      if (Object.keys(errors).length > 0) {
        setCustomFormErrors(errors);
        return;
      }

      setCustomFormErrors({ selectedTypes: null, otherValue: null });

      const res = await updateBusinessProfile(
        profile?.business?.type === "skypoint"
          ? {
              companyName: values.companyName,
              businessTypes: selectedTypes,
            }
          : values
      );

      if (res) {
        setOtherValue("");
        setShowOtherInput(false);
      }
    } catch (error) {}
  };

  return (
    <>
      <form onSubmit={form?.onSubmit((values) => onFinish(values))}>
        <Card className={classes.wrapper} pb={30}>
          <Container fluid sx={{ width: "100%" }}>
            {profile?.business?.type === "skypoint" ? (
              <SimpleGrid cols={3} className={classes.inputContainer}>
                <TextInput
                  label={"Business Name*"}
                  size="md"
                  icon={
                    <img
                      src={"/assets/images/profile.png"}
                      alt=""
                      className={classes.inputIcon}
                    />
                  }
                  {...form.getInputProps("companyName")}
                />
                {/* <TextInput
                  label={"Email"}
                  size="md"
                  icon={
                    <img
                      src={"/assets/images/sms.png"}
                      alt=""
                      className={classes.inputIcon}
                    />
                  }
                  {...form.getInputProps("businessEmail")}
                  disabled
                /> */}
                <Select
                  label="Business type*"
                  placeholder="Select an option"
                  data={mockBusinessTypes}
                  size="md"
                  clearable
                  value={null}
                  onChange={(value) => handleSelectChange(value)}
                  rightSection={<GoChevronDown color="#94A3B8" size={16} />}
                  error={customFormErrors.selectedTypes}
                />
                {showOtherInput && (
                  <TextInput
                    placeholder="Enter type and press Enter"
                    value={otherValue}
                    label="Other"
                    onChange={(e) => setOtherValue(e.target.value)}
                    onKeyDown={handleOtherInputKeyDown}
                    error={customFormErrors.otherValue}
                    size="md"
                  />
                )}
                <Box>
                  <Text fw={500} fz={16} color="#212529">
                    Selected Types
                  </Text>
                  <Flex
                    gap={8}
                    wrap="wrap"
                    className={classes.selectedTypesWrapper}
                  >
                    {selectedTypes?.map((type, index) => (
                      <Flex
                        gap={4}
                        align="center"
                        justify="center"
                        key={index}
                        className={classes.selectedTypeTag}
                      >
                        <Text
                          fz={14}
                          fw={500}
                          ff="Inter"
                          color="#344054"
                          align="center"
                        >
                          {type}
                        </Text>
                        <CloseButton
                          icon={<IoClose color="#667085" size={18} />}
                          onClick={() =>
                            setSelectedTypes(
                              selectedTypes.filter((t) => t !== type)
                            )
                          }
                        />
                      </Flex>
                    ))}
                  </Flex>
                </Box>
              </SimpleGrid>
            ) : (
              <SimpleGrid cols={3} className={classes.inputContainer}>
                <TextInput
                  label={"Company Name*"}
                  size="md"
                  icon={
                    <img
                      src={"/assets/images/profile.png"}
                      alt=""
                      className={classes.inputIcon}
                    />
                  }
                  {...form.getInputProps("companyName")}
                />
                <TextInput
                  label={"Email"}
                  size="md"
                  icon={
                    <img
                      src={"/assets/images/sms.png"}
                      alt=""
                      className={classes.inputIcon}
                    />
                  }
                  {...form.getInputProps("businessEmail")}
                  disabled
                />
                <div className={classes.phoneInputBox}>
                  <p className={classes.label}>Phone number</p>
                  <PhoneInput
                    defaultCountry="us"
                    // value={phone}
                    // onChange={(phone) => setPhone(phone)}
                    {...form.getInputProps("contactPhone")}
                    className={classes.phoneInput}

                    // disabled={view}
                  />
                </div>
                <Select
                  label={"Industry"}
                  size="md"
                  searchable
                  icon={
                    <img
                      src={"/assets/images/lock.png"}
                      alt=""
                      className={classes.inputIcon}
                    />
                  }
                  {...form.getInputProps("industry", { type: "select" })}
                  data={[
                    {
                      value: "health care",
                      label: "Health Care",
                    },
                    { value: "transportation", label: "Transportation" },
                  ]}
                />
              </SimpleGrid>
            )}
          </Container>
        </Card>
        <SimpleGrid
          cols={2}
          sx={{ margin: "auto", marginTop: 25, marginBottom: 10 }}
        >
          <Button
            ml={"auto"}
            color="yellow"
            variant="light"
            className={classes.btn}
            onClick={() => navigate("/home/dashboard")}
          >
            Cancel
          </Button>
          <Button
            mr={"auto"}
            type="submit"
            color="yellow"
            className={classes.btn}
            loading={saveProfileLoading}
          >
            Save
          </Button>
        </SimpleGrid>
      </form>
    </>
  );
};

export default BusinessProfile;
